import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { getMessage } from 'util/locale';

const OverlaySelectLayers = ({
  extendedHeight,
  layerGroup,
  selectedLayer,
  onSelect
}) => {
  const classString = classNames({
    'form-control': true,
    'vra-layer-selector__select': true,
    'vra-layer-selector__select--extended': extendedHeight
  });

  const layerList = [];

  layerGroup.layers.forEach( (layer) => {
    const layerClassString = classNames({
      'vra-layer-selector__option': true,
      'vra-layer-selector__option--selected': selectedLayer === layer
    });
    layerList.push(
      <div
        data-test-id="map-layer-selector"
        className={layerClassString}
        key={layer}
        onClick={ () => onSelect(layer) }
      >
        {getMessage(`label-text__overlay-layer--${layer}`) || layer}
      </div>
    );
  });

  return (
    <div className={classString}>
      {layerList}
    </div>
  );
};

OverlaySelectLayers.propTypes = {
  extendedHeight: propTypes.bool,
  layerGroup: propTypes.object.isRequired,
  onSelect: propTypes.func.isRequired,
  selectedLayer: propTypes.string
};
export default OverlaySelectLayers;
